import { NgModule } from '@angular/core';
import { RouterModule, Routes, NoPreloading } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { PermissionGuard } from './core/guards/permission.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, PermissionGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'daily-roaster',
        loadChildren: () => import('./features/daily-roaster/daily-roaster.module').then(m => m.DailyRoasterModule)
      },
      {
        path: 'patient',
        loadChildren: () => import('./features/patients/patients.module').then(m => m.PatientsModule)
      },
      {
        path: 'scheduler',
        loadChildren: () => import('./features/scheduler/scheduler.module').then(m => m.SchedulerModule)
      },
      {
        path: 'batch',
        loadChildren: () => import('./features/batch/batch.module').then(m => m.BatchModule)
      },
      {
        path: 'user',
        loadChildren: () => import('./features/user/user.module').then(m => m.UserModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'master',
        loadChildren: () => import('./features/master/master.module').then(m => m.MasterModule)
      },
      {
        path: 'follow-up',
        loadChildren: () => import('./features/follow-up/follow-up.module').then(m => m.FollowUpModule)
      }

    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    scrollPositionRestoration: 'top',
    // Do not download every feature module on login (was 3–4 min first load on slow links).
    preloadingStrategy: NoPreloading
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
